const mediaItems = [
  {
    title: '《秘密恋爱笔记》动画PV首发',
    desc: '人气恋爱韩漫动画化决定！官方预告片PV全球首发，精美作画引爆期待',
    duration: '02:18',
    img: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20video%20thumbnail%20style%20art%20featuring%20animated%20comic%20panel%20preview%20with%20warm%20lighting%20play%20button%20overlay%20cinematic%20look%20professional%20thumbnail%20design%20clean%20composition&width=800&height=450&seq=media-kr-01&orientation=landscape',
  },
  {
    title: '《剑与魔法纪元》特别篇预告',
    desc: '为庆祝连载两周年，官方推出特别篇动画短片，全新剧情首次公开',
    duration: '03:45',
    img: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20episode%20preview%20thumbnail%20art%20featuring%20key%20scene%20moment%20warm%20dramatic%20lighting%20professional%20video%20thumbnail%20style%20clean%20composition%20golden%20atmosphere&width=800&height=450&seq=media-kr-02&orientation=landscape',
  },
  {
    title: '人气画师SUN-HEE角色设计赏析',
    desc: '深度赏析金牌画师的角色设计过程，从草图到成稿的完整创作记录',
    duration: '08:12',
    img: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20character%20spotlight%20thumbnail%20art%20featuring%20detailed%20character%20portrait%20warm%20studio%20lighting%20professional%20media%20thumbnail%20style%20elegant%20composition%20creative%20atmosphere&width=800&height=450&seq=media-kr-03&orientation=landscape',
  },
  {
    title: '韩漫改编动画幕后制作花絮',
    desc: '走进韩国动画工作室，揭秘热门韩漫从纸质到荧幕的完整制作流程',
    duration: '12:30',
    img: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20behind%20the%20scenes%20thumbnail%20art%20featuring%20artist%20workspace%20with%20warm%20ambient%20lighting%20professional%20media%20thumbnail%20style%20creative%20atmosphere%20soft%20golden%20tones&width=800&height=450&seq=media-kr-04&orientation=landscape',
  },
  {
    title: '七月新番韩漫导读与推荐',
    desc: '本月新上线20部韩漫作品全面解析，从剧情到画风一一为你详细盘点',
    duration: '06:50',
    img: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20review%20discussion%20thumbnail%20art%20featuring%20comic%20panels%20collage%20warm%20tones%20professional%20media%20thumbnail%20style%20engaging%20composition%20clean%20layout&width=800&height=450&seq=media-kr-05&orientation=landscape',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="w-full py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 text-center mb-3">
          精彩视频
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">
          韩漫相关动画PV、创作花絮与深度解说
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {mediaItems.map((item, i) => (
            <a
              key={i}
              href="#media"
              className="group block bg-background-50 rounded-lg border border-background-200/70 overflow-hidden transition-all duration-300 hover:border-primary-200 cursor-pointer"
            >
              <div className="relative aspect-video overflow-hidden bg-background-200">
                <img
                  src={item.img}
                  alt={`韩漫视频 - ${item.title}`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-foreground-950/20 group-hover:bg-foreground-950/10 transition-colors"></div>
                <div className="absolute bottom-2 right-2 px-2 py-0.5 bg-foreground-950/70 text-background-50 text-xs rounded whitespace-nowrap">
                  {item.duration}
                </div>
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-12 h-12 flex items-center justify-center rounded-full bg-background-50/90 text-primary-500 group-hover:scale-110 transition-transform duration-300">
                    <i className="ri-play-fill text-2xl"></i>
                  </div>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-sm md:text-base font-heading font-bold text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-2 mb-1">
                  {item.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-500 line-clamp-2 leading-relaxed">
                  {item.desc}
                </p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}